import { ADD_ENTITIES } from "../actions/actions";
import { mergeEntitiesWithState, panelManufacturer } from "../helpers/schema";

const schema = panelManufacturer;

export function panelManufacturers(
  state = {
    all: {},
  },
  action
) {
  switch (action.type) {
    case ADD_ENTITIES:
      let data = action.payload.panelManufacturer;
      if (!data) return state;

      return {
        ...state,
        all: mergeEntitiesWithState(data, state.all, schema),
      };
    default:
      return state;
  }
}
